// extracted by mini-css-extract-plugin
export default {"tenorMedia":"TenorMedia-tenorMedia-e4cec8e5a5357d1890e3ac6b056ad9cb","tenorMediaImage":"TenorMedia-tenorMediaImage-0397b4f460aa042b01db95d90acc3000"};